import React from 'react';

import classNames from 'classnames/bind';
import style from './Quote.scss';
const ctx = classNames.bind(style);

const Quote = props => (
  <div className={ctx('quote')}>
    <div className={ctx('author')}>
      {props.author && (
        <div>
          <img
            className={ctx('photo')}
            width="128px"
            src={props.author.photo}
          />
          <div className={ctx('nick')}>{props.author.nick}</div>
          <div className={ctx('position')}>{props.author.position}</div>
          <div className={ctx('job')}>
            <a
              href="https://bs.serving-sys.com/serving/adServer.bs?cn=trd&mc=click&pli=26540508&PluID=0&ord=%%RANDOM%%"
              target="_blank"
            >
              {props.author.job}
            </a>
          </div>
          <div className={ctx('job')}>
            <a
              href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article2&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article2"
              target="_blank"
            >
              {props.author.job1}
            </a>
          </div>
          <div className={ctx('job')}>
            <a
              href="https://alfabank.ru/alfaprivate/?platformId=kommersant_special_project_alfaprivate_article3&utm_source=kommersant&utm_medium=special_project&utm_campaign=alfaprivate&utm_term=null&utm_content=article3"
              target="_blank"
            >
              {props.author.job2}
            </a>
          </div>
        </div>
      )}
    </div>
    <div className={ctx('text')}>{props.children}</div>
  </div>
);

export default Quote;
